var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-fullscreen-container",
    [
      _vm.$wf.isSmDown
        ? _c(
            "app-toolbar",
            [
              _c(
                "w-toolbar-item",
                {
                  attrs: { disabled: _vm.saving || !_vm.isValid },
                  on: {
                    click: function ($event) {
                      return _vm.save(false)
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "save" } })],
                1
              ),
              _c(
                "w-toolbar-item",
                {
                  attrs: { disabled: _vm.saving },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-breadcrumb",
        [
          !_vm.$wf.isSmDown
            ? _c(
                "w-row",
                { attrs: { grow: "" } },
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c(
                        "w-row",
                        { attrs: { "no-wrap": "" } },
                        [
                          _c("w-tabs", {
                            attrs: { tabs: _vm.tabs },
                            model: {
                              value: _vm.selectedTab,
                              callback: function ($$v) {
                                _vm.selectedTab = $$v
                              },
                              expression: "selectedTab",
                            },
                          }),
                          _c("w-spacer"),
                          _c(
                            "w-button",
                            {
                              staticClass: "cancel mr",
                              on: {
                                click: function ($event) {
                                  return _vm.cancel()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("common.cancel")) + " "
                              ),
                            ]
                          ),
                          _vm.selectedTab == 1
                            ? _c(
                                "w-button",
                                {
                                  staticClass: "mr",
                                  attrs: { icon: "plus" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.saveContinue()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$ct("labels.new")) + " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.selectedTab != 1
                            ? _c(
                                "w-button",
                                {
                                  attrs: {
                                    icon: "check",
                                    disabled: _vm.saving || !_vm.isValid,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.save(false)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("common.save")) + " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("app-bank-edit-default", {
                    attrs: {
                      "clear-batch": _vm.clearBatch,
                      history: _vm.historySeries,
                      bank: _vm.bank,
                    },
                    on: {
                      update: function ($event) {
                        return _vm.onUpdateBatch($event)
                      },
                      valid: function ($event) {
                        _vm.isDefaultValid = $event
                      },
                    },
                  }),
                ],
                1
              ),
              _vm.selectedTab == 1
                ? _c(
                    "w-col",
                    { style: { paddingTop: 0 }, attrs: { xs: "12", md: "6" } },
                    [
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { sm: "12", md: "12", lg: "12" } },
                            [
                              _c(
                                "w-card",
                                [
                                  _c("w-card-title", [
                                    _vm._v(
                                      _vm._s(_vm.$ct("titles.historyList"))
                                    ),
                                  ]),
                                  _c(
                                    "w-card-content",
                                    { style: { padding: 0 } },
                                    [
                                      _c("app-custom-table", [
                                        _c("thead", [
                                          _c("tr", [
                                            _c(
                                              "th",
                                              {
                                                staticStyle: { width: "85px" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$ct(
                                                      "serie-columns.date"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "th",
                                              { staticClass: "amount" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$ct(
                                                      "serie-columns.amount"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c("th", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$ct(
                                                    "serie-columns.client-supplier"
                                                  )
                                                )
                                              ),
                                            ]),
                                            _c("th", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$ct(
                                                    "serie-columns.invoice-number"
                                                  )
                                                )
                                              ),
                                            ]),
                                            _c("th", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$ct("serie-columns.info")
                                                )
                                              ),
                                            ]),
                                            _c("th"),
                                          ]),
                                        ]),
                                        _c(
                                          "tbody",
                                          [
                                            _vm._l(
                                              _vm.historySeries,
                                              function (history, index) {
                                                return _c(
                                                  "app-bank-edit-history-item",
                                                  {
                                                    key: index,
                                                    attrs: { history: history },
                                                  }
                                                )
                                              }
                                            ),
                                            !_vm.historySeries.length
                                              ? _c("tr", [
                                                  _c(
                                                    "td",
                                                    { attrs: { colspan: "6" } },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$ct(
                                                              "titles.historyListEmpty"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                        _c("tfoot", [
                                          _c("tr", [
                                            _c(
                                              "td",
                                              {
                                                staticClass: "amount",
                                                attrs: { colspan: "2" },
                                              },
                                              [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$ct("total-booked")
                                                    ) + " "
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.serieTotalString
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c("td"),
                                            _c("td"),
                                            _c("td"),
                                            _c("td"),
                                          ]),
                                        ]),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.balanceCheck
                            ? _c(
                                "w-col",
                                { attrs: { sm: "12", md: "12", lg: "12" } },
                                [
                                  _c(
                                    "w-card",
                                    [
                                      _c("w-card-title", [
                                        _vm._v(_vm._s(_vm.$ct("check-title"))),
                                      ]),
                                      _c(
                                        "w-card-content",
                                        [
                                          _c(
                                            "w-row",
                                            [
                                              _c(
                                                "w-col",
                                                { attrs: { md: "5" } },
                                                [
                                                  _c("w-input-number", {
                                                    attrs: {
                                                      label:
                                                        _vm.$ct("labels.start"),
                                                      fancy: "",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "w-col",
                                                { attrs: { md: "1" } },
                                                [
                                                  _c("w-fa", {
                                                    attrs: {
                                                      icon: "not-equal",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "w-col",
                                                { attrs: { md: "5" } },
                                                [
                                                  _c("w-input-number", {
                                                    attrs: {
                                                      label:
                                                        _vm.$ct("labels.end"),
                                                      fancy: "",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("app-extra-fields-edit", {
                        attrs: { value: _vm.bank },
                      }),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }